import React, { useState } from "react";
import PropTypes from "prop-types";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import { useApi } from "../../../../../context/api.js";
import MDButton from "../../../../../components/MDButton";
import MDTypography from "../../../../../components/MDTypography";
import CircularProgress from "@mui/material/CircularProgress";
import { formatDate } from "../../../../../utils/date.js";
import { setMilestone, useHomework } from "../../../../../context/homework";

function ParentValidation({ m, from, title, onCancel }) {
  const api = useApi();
  const [_, dispatch] = useHomework();
  const [loading, setLoading] = useState(0);

  const handleReject = () => {
    setLoading(2);
    api
      .rejectMilestone(m.id, from)
      .then((res) => {
        setLoading(0);
        if (res) {
          setMilestone(dispatch, m.id, from);
          onCancel();
        } else {
          // TODO : Show error ?
        }
      })
      .catch((err) => {
        setLoading(false);
        // TODO : Show error ?
      });
  };
  const handleAccept = () => {
    setLoading(1);
    api
      .validateMilestone(m.id, from)
      .then((res) => {
        setLoading(0);
        if (res) {
          setMilestone(dispatch, m.id, from, null);
          onCancel();
        } else {
          // TODO : Show error ?
        }
      })
      .catch((err) => {
        setLoading(false);
        // TODO : Show error ?
      });
  };

  return (
    <>
      <DialogContent>
        {title}
        <MDTypography variant="body" component="div" mt={2}>
          {m.submitted
            ? "Votre enfant vous a notifié avoir terminé cette étape le " +
              formatDate(m.submission_date) +
              "."
            : "Vous êtes sur le point de valider cette étape de votre enfant."}
        </MDTypography>
      </DialogContent>
      <DialogActions>
        {m.submitted && (
          <MDButton variant="contained" color="error" disabled={!!loading} onClick={handleReject}>
            {loading === 2 && <CircularProgress size={24} />}
            {loading !== 2 && "Refuser son étape"}
          </MDButton>
        )}
        <MDButton variant="contained" color="success" disabled={!!loading} onClick={handleAccept}>
          {loading === 1 && <CircularProgress size={24} />}
          {loading !== 1 && "Valider son étape"}
        </MDButton>
      </DialogActions>
    </>
  );
}

ParentValidation.propTypes = {
  m: PropTypes.object.isRequired,
  from: PropTypes.string.isRequired,
  onCancel: PropTypes.func.isRequired,
  title: PropTypes.element,
};

export default ParentValidation;
